export const vernacularData = {
  hindi: {
    language: 'Hindi',
    nativeName: 'हिंदी',
    title: 'Book Hindi Newspaper Ads',
    headline: 'हिंदी समाचार पत्रों में विज्ञापन बुक करें',
    subheadline: 'Dainik Bhaskar, Dainik Jagran, Hindustan aur anya pramukh akhbaron mein.',
    newspapers: [
      { name: 'Dainik Bhaskar', logo: 'https://www.google.com/s2/favicons?domain=dainikbhaskar.com&sz=128' },
      { name: 'Dainik Jagran', logo: 'https://www.google.com/s2/favicons?domain=jagran.com&sz=128' },
      { name: 'Hindustan', logo: 'https://www.google.com/s2/favicons?domain=livehindustan.com&sz=128' },
      { name: 'Amar Ujala', logo: 'https://www.google.com/s2/favicons?domain=amarujala.com&sz=128' },
      { name: 'Navbharat Times', logo: 'https://www.google.com/s2/favicons?domain=navbharattimes.indiatimes.com&sz=128' },
      { name: 'Rajasthan Patrika', logo: 'https://www.google.com/s2/favicons?domain=patrika.com&sz=128' },
      { name: 'Punjab Kesari', logo: 'https://www.google.com/s2/favicons?domain=punjabkesari.in&sz=128' },
      { name: 'Prabhat Khabar', logo: 'https://www.google.com/s2/favicons?domain=prabhatkhabar.com&sz=128' },
      { name: 'Jansatta', logo: 'https://www.google.com/s2/favicons?domain=jansatta.com&sz=128' },
      { name: 'Other', logo: 'https://placehold.co/128x128?text=Other' }
    ],
    whatsappMessage: 'Namaste, mujhe Hindi newspaper mein ad book karna hai.',
    content: {
      whyAdvertise: 'हिंदी समाचार पत्रों में विज्ञापन क्यों दें?',
      targetedReach: { title: 'लक्षित पहुंच (Targeted Reach)', desc: 'हिंदी भाषी समुदाय के दिल तक पहुंचें। क्षेत्रीय समाचार पत्रों के पास एक वफादार पाठक वर्ग है जो स्थानीय समाचारों पर भरोसा करता है।' },
      costEffective: { title: 'किफायती (Cost Effective)', desc: 'क्षेत्रीय समाचार पत्रों में विज्ञापन देना अक्सर राष्ट्रीय अंग्रेजी दैनिकों की तुलना में 30-50% सस्ता होता है, जिससे आपको बेहतर ROI मिलता है।' },
      higherEngagement: { title: 'अधिक जुड़ाव (Higher Engagement)', desc: 'पाठक अपनी मातृभाषा के समाचार पत्रों पर अधिक समय बिताते हैं। हिंदी में आपका विज्ञापन अधिक ध्यान आकर्षित करता है।' },
      howToBook: 'हिंदी विज्ञापन ऑनलाइन कैसे बुक करें?',
      steps: [
        { title: 'अखबार चुनें', desc: 'दैनिक भास्कर या दैनिक जागरण जैसे लोकप्रिय अखबारों में से चुनें।' },
        { title: 'अपना विज्ञापन ड्राफ्ट करें', desc: 'अपना विज्ञापन हिंदी या अंग्रेजी में लिखें। हम मुफ्त अनुवाद सहायता प्रदान करते हैं!' },
        { title: 'हमें व्हाट्सएप करें', desc: 'अपना विवरण भेजने के लिए नीचे दिए गए बटन पर क्लिक करें। हम तुरंत सबसे कम रेट साझा करेंगे।' }
      ]
    }
  },
  marathi: {
    language: 'Marathi',
    nativeName: 'मराठी',
    title: 'Book Marathi Newspaper Ads',
    headline: 'मराठी वर्तमानपत्रात जाहिरात बुक करा',
    subheadline: 'Lokmat, Sakal, Pudhari ani itar pramukh vartamanpatrat.',
    newspapers: [
      { name: 'Lokmat', logo: 'https://www.google.com/s2/favicons?domain=lokmat.com&sz=128' },
      { name: 'Sakal', logo: 'https://www.google.com/s2/favicons?domain=esakal.com&sz=128' },
      { name: 'Pudhari', logo: 'https://www.google.com/s2/favicons?domain=pudhari.news&sz=128' },
      { name: 'Maharashtra Times', logo: 'https://www.google.com/s2/favicons?domain=maharashtratimes.com&sz=128' },
      { name: 'Saamana', logo: 'https://www.google.com/s2/favicons?domain=saamana.com&sz=128' },
      { name: 'Tarun Bharat', logo: 'https://www.google.com/s2/favicons?domain=tarunbharat.net&sz=128' },
      { name: 'Punya Nagari', logo: 'https://www.google.com/s2/favicons?domain=punyanagari.com&sz=128' },
      { name: 'Deshdoot', logo: 'https://www.google.com/s2/favicons?domain=deshdoot.com&sz=128' },
      { name: 'Other', logo: 'https://placehold.co/128x128?text=Other' }
    ],
    whatsappMessage: 'Namaskar, mala Marathi newspaper madhe ad book karaychi aahe.',
    content: {
      whyAdvertise: 'मराठी वर्तमानपत्रात जाहिरात का द्यावी?',
      targetedReach: { title: 'लक्षित पोहोच (Targeted Reach)', desc: 'मराठी भाषिक समुदायापर्यंत पोहोचा. प्रादेशिक वर्तमानपत्रांचा वाचकवर्ग एकनिष्ठ असतो.' },
      costEffective: { title: 'किफायतशीर (Cost Effective)', desc: 'प्रादेशिक वर्तमानपत्रात जाहिरात देणे इंग्रजी दैनिकांपेक्षा 30-50% स्वस्त असते, ज्यामुळे तुम्हाला चांगला परतावा मिळतो.' },
      higherEngagement: { title: 'अधिक वाचक (Higher Engagement)', desc: 'वाचक आपल्या मातृभाषेतील वर्तमानपत्रांवर जास्त वेळ घालवतात. मराठीतील तुमची जाहिरात जास्त लक्ष वेधून घेते.' },
      howToBook: 'मराठी जाहिरात ऑनलाइन कशी बुक करावी?',
      steps: [
        { title: 'वर्तमानपत्र निवडा', desc: 'लोकमत किंवा सकाळ सारख्या लोकप्रिय वर्तमानपत्रांमधून निवडा.' },
        { title: 'तुमची जाहिरात लिहा', desc: 'तुमची जाहिरात मराठी किंवा इंग्रजीमध्ये लिहा. आम्ही मोफत भाषांतर मदत देतो!' },
        { title: 'आम्हाला व्हॉट्सॲप करा', desc: 'तपशील पाठवण्यासाठी खालील बटणावर क्लिक करा. आम्ही त्वरित सर्वात कमी दर सांगू.' }
      ]
    }
  },
  tamil: {
    language: 'Tamil',
    nativeName: 'தமிழ்',
    title: 'Book Tamil Newspaper Ads',
    headline: 'தமிழ் செய்தித்தாள்களில் விளம்பரம் செய்யுங்கள்',
    subheadline: 'Daily Thanthi, Dinamalar, Dinakaran matrum pala.',
    newspapers: [
      { name: 'Daily Thanthi', logo: 'https://www.google.com/s2/favicons?domain=dailythanthi.com&sz=128' },
      { name: 'Dinamalar', logo: 'https://www.google.com/s2/favicons?domain=dinamalar.com&sz=128' },
      { name: 'Dinakaran', logo: 'https://www.google.com/s2/favicons?domain=dinakaran.com&sz=128' },
      { name: 'Dinamani', logo: 'https://www.google.com/s2/favicons?domain=dinamani.com&sz=128' },
      { name: 'Hindu Tamil Thisai', logo: 'https://www.google.com/s2/favicons?domain=hindutamil.in&sz=128' },
      { name: 'Maalai Malar', logo: 'https://www.google.com/s2/favicons?domain=maalaimalar.com&sz=128' },
      { name: 'Other', logo: 'https://placehold.co/128x128?text=Other' }
    ],
    whatsappMessage: 'Vanakkam, Tamil newspaperil ad book seiya vendum.',
    content: {
      whyAdvertise: 'தமிழ் செய்தித்தாள்களில் ஏன் விளம்பரம் செய்ய வேண்டும்?',
      targetedReach: { title: 'இலக்கு அடைவு (Targeted Reach)', desc: 'தமிழ் பேசும் மக்களை நேரடியாகச் சென்றடையுங்கள். பிராந்திய செய்தித்தாள்கள் வாசகர்களின் நம்பிக்கையைப் பெற்றுள்ளன.' },
      costEffective: { title: 'குறைந்த செலவு (Cost Effective)', desc: 'ஆங்கில நாளிதழ்களை விட பிராந்திய செய்தித்தாள்களில் விளம்பரம் செய்வது 30-50% மலிவானது.' },
      higherEngagement: { title: 'அதிக ஈடுபாடு (Higher Engagement)', desc: 'வாசகர்கள் தங்கள் தாய்மொழி செய்தித்தாள்களை விரும்பிப் படிக்கிறார்கள். தமிழில் உங்கள் விளம்பரம் அதிக கவனத்தைப் பெறும்.' },
      howToBook: 'தமிழ் விளம்பரங்களை ஆன்லைனில் முன்பதிவு செய்வது எப்படி?',
      steps: [
        { title: 'செய்தித்தாளையைத் தேர்ந்தெடுக்கவும்', desc: 'தினத்தந்தி அல்லது தினமலர் போன்ற பிரபலமான செய்தித்தாள்களைத் தேர்ந்தெடுக்கவும்.' },
        { title: 'உங்கள் விளம்பரத்தை எழுதவும்', desc: 'உங்கள் விளம்பரத்தை தமிழ் அல்லது ஆங்கிலத்தில் எழுதவும். நாங்கள் இலவச மொழிபெயர்ப்பு உதவுகிறோம்!' },
        { title: 'எங்களுக்கு வாட்ஸ்அப் செய்யவும்', desc: 'விவரங்களை அனுப்ப கீழே உள்ள பொத்தானைக் கிளிக் செய்யவும். குறைந்த கட்டணத்தை நாங்கள் பகிர்வோம்.' }
      ]
    }
  },
  malayalam: {
    language: 'Malayalam',
    nativeName: 'മലയാളം',
    title: 'Book Malayalam Newspaper Ads',
    headline: 'മലയാളം പത്രങ്ങളിൽ പരസ്യം നൽകൂ',
    subheadline: 'Malayala Manorama, Mathrubhumi, Deshabhimani.',
    newspapers: [
      { name: 'Malayala Manorama', logo: 'https://www.google.com/s2/favicons?domain=manoramaonline.com&sz=128' },
      { name: 'Mathrubhumi', logo: 'https://www.google.com/s2/favicons?domain=mathrubhumi.com&sz=128' },
      { name: 'Deshabhimani', logo: 'https://www.google.com/s2/favicons?domain=deshabhimani.com&sz=128' },
      { name: 'Madhyamam', logo: 'https://www.google.com/s2/favicons?domain=madhyamam.com&sz=128' },
      { name: 'Kerala Kaumudi', logo: 'https://www.google.com/s2/favicons?domain=keralakaumudi.com&sz=128' },
      { name: 'Mangalam', logo: 'https://www.google.com/s2/favicons?domain=mangalam.com&sz=128' },
      { name: 'Janmabhumi', logo: 'https://www.google.com/s2/favicons?domain=janmabhumi.in&sz=128' },
      { name: 'Chandrika', logo: 'https://www.google.com/s2/favicons?domain=chandrikadaily.com&sz=128' },
      { name: 'Suprabhaatham', logo: 'https://www.google.com/s2/favicons?domain=suprabhaatham.com&sz=128' },
      { name: 'Other', logo: 'https://placehold.co/128x128?text=Other' }
    ],
    whatsappMessage: 'Namaskaram, Malayalam pathrathil ad book cheyyanam.',
    content: {
      whyAdvertise: 'മലയാളം പത്രങ്ങളിൽ എന്തിന് പരസ്യം നൽകണം?',
      targetedReach: { title: 'ലക്ഷ്യമിട്ട റീച്ച് (Targeted Reach)', desc: 'മലയാളം സംസാരിക്കുന്നവരിലേക്ക് നേരിട്ടെത്തുക. പ്രാദേശിക പത്രങ്ങൾക്ക് വിശ്വസ്തരായ വായനക്കാരുണ്ട്.' },
      costEffective: { title: 'കുറഞ്ഞ ചെലവ് (Cost Effective)', desc: 'ഇംഗ്ലീഷ് പത്രങ്ങളെ അപേക്ഷിച്ച് പ്രാദേശിക പത്രങ്ങളിൽ പരസ്യം നൽകുന്നത് 30-50% ലാഭകരമാണ്.' },
      higherEngagement: { title: 'കൂടുതൽ ശ്രദ്ധ (Higher Engagement)', desc: 'വായനക്കാർ മാതൃഭാഷാ പത്രങ്ങളിൽ കൂടുതൽ സമയം ചെലവഴിക്കുന്നു. നിങ്ങളുടെ പരസ്യം കൂടുതൽ ശ്രദ്ധിക്കപ്പെടും.' },
      howToBook: 'മലയാളം പരസ്യങ്ങൾ ഓൺലൈനായി എങ്ങനെ ബുക്ക് ചെയ്യാം?',
      steps: [
        { title: 'പത്രം തിരഞ്ഞെടുക്കുക', desc: 'മലയാള മനോരമ അല്ലെങ്കിൽ മാതൃഭൂമി പോലുള്ള പ്രമുഖ പത്രങ്ങൾ തിരഞ്ഞെടുക്കുക.' },
        { title: 'പരസ്യം തയ്യാറാക്കുക', desc: 'നിങ്ങളുടെ പരസ്യം മലയാളത്തിലോ ഇംഗ്ലീഷിലോ എഴുതുക. ഞങ്ങൾ സൗജന്യ വിവർത്തന സഹായം നൽകുന്നു!' },
        { title: 'വാട്ട്‌സ്ആപ്പ് ചെയ്യുക', desc: 'വിശദാംശങ്ങൾ അയക്കാൻ താഴെയുള്ള ബട്ടൺ ക്ലിക്ക് ചെയ്യുക. ഏറ്റവും കുറഞ്ഞ നിരക്ക് ഞങ്ങൾ അറിയിക്കും.' }
      ]
    }
  },
  bengali: {
    language: 'Bengali',
    nativeName: 'বাংলা',
    title: 'Book Bengali Newspaper Ads',
    headline: 'বাংলা সংবাদপত্রে বিজ্ঞাপন দিন',
    subheadline: 'Anandabazar Patrika, Bartaman, Sangbad Pratidin.',
    newspapers: [
      { name: 'Anandabazar Patrika', logo: 'https://www.google.com/s2/favicons?domain=anandabazar.com&sz=128' },
      { name: 'Bartaman', logo: 'https://www.google.com/s2/favicons?domain=bartamanpatrika.com&sz=128' },
      { name: 'Sangbad Pratidin', logo: 'https://www.google.com/s2/favicons?domain=sangbadpratidin.in&sz=128' },
      { name: 'Aajkaal', logo: 'https://www.google.com/s2/favicons?domain=aajkaal.in&sz=128' },
      { name: 'Ei Samay', logo: 'https://www.google.com/s2/favicons?domain=eisamay.com&sz=128' },
      { name: 'Ganashakti', logo: 'https://www.google.com/s2/favicons?domain=ganashakti.com&sz=128' },
      { name: 'Uttarbanga Sambad', logo: 'https://www.google.com/s2/favicons?domain=uttarbangasambad.com&sz=128' },
      { name: 'Other', logo: 'https://placehold.co/128x128?text=Other' },
    ],
    whatsappMessage: 'Nomoshkar, ami Bengali newspaper e ad dite chai.',
    content: {
      whyAdvertise: 'বাংলা সংবাদপত্রে বিজ্ঞাপন কেন দেবেন?',
      targetedReach: { title: 'সঠিক পাঠকের কাছে পৌঁছান', desc: 'বাংলাভাষী মানুষের কাছে সরাসরি পৌঁছান। আঞ্চলিক সংবাদপত্রের পাঠকরা স্থানীয় খবরের ওপর ভরসা করেন।' },
      costEffective: { title: 'কম খরচ (Cost Effective)', desc: 'ইংরেজি সংবাদপত্রের তুলনায় আঞ্চলিক সংবাদপত্রে বিজ্ঞাপন দেওয়া ৩০-৫০% সস্তা।' },
      higherEngagement: { title: 'বেশি মনোযোগ (Higher Engagement)', desc: 'পাঠকরা তাদের মাতৃভাষার সংবাদপত্র পড়তে বেশি সময় দেন। বাংলায় আপনার বিজ্ঞাপন বেশি নজরে পড়ে।' },
      howToBook: 'বাংলা বিজ্ঞাপন অনলাইনে কীভাবে বুক করবেন?',
      steps: [
        { title: 'সংবাদপত্র বাছুন', desc: 'আনন্দবাজার পত্রিকা বা বর্তমানের মতো জনপ্রিয় সংবাদপত্র বেছে নিন।' },
        { title: 'বিজ্ঞাপন লিখুন', desc: 'আপনার বিজ্ঞাপন বাংলা বা ইংরেজিতে লিখুন। আমরা বিনামূল্যে অনুবাদের সাহায্য দিই!' },
        { title: 'হোয়াটসঅ্যাপ করুন', desc: 'বিস্তারিত পাঠাতে নিচের বোতামে ক্লিক করুন। আমরা সবচেয়ে কম রেট জানাব।' }
      ]
    }
  },
  kannada: {
    language: 'Kannada',
    nativeName: 'ಕನ್ನಡ',
    title: 'Book Kannada Newspaper Ads',
    headline: 'ಕನ್ನಡ ಪತ್ರಿಕೆಗಳಲ್ಲಿ ಜಾಹೀರಾತು ನೀಡಿ',
    subheadline: 'Vijayavani, Prajavani, Kannada Prabha mattu itara.',
    newspapers: [
      { name: 'Vijayavani', logo: 'https://www.google.com/s2/favicons?domain=vijayavani.net&sz=128' },
      { name: 'Prajavani', logo: 'https://www.google.com/s2/favicons?domain=prajavani.net&sz=128' },
      { name: 'Kannada Prabha', logo: 'https://www.google.com/s2/favicons?domain=kannadaprabha.com&sz=128' },
      { name: 'Udayavani', logo: 'https://www.google.com/s2/favicons?domain=udayavani.com&sz=128' },
      { name: 'Samyuktha Karnataka', logo: 'https://www.google.com/s2/favicons?domain=samyukthakarnataka.com&sz=128' },
      { name: 'Sanjevani', logo: 'https://www.google.com/s2/favicons?domain=sanjevani.com&sz=128' },
      { name: 'Vijaya Karnataka', logo: 'https://www.google.com/s2/favicons?domain=vijaykarnataka.com&sz=128' },
      { name: 'Hosa Digantha', logo: 'https://www.google.com/s2/favicons?domain=epaper.hosadigantha.com&sz=128' },
      { name: 'Vishwavani', logo: 'https://www.google.com/s2/favicons?domain=vishwavani.news&sz=128' },
      { name: 'Other', logo: 'https://placehold.co/128x128?text=Other' },
    ],
    whatsappMessage: 'Namaskara, nanage Kannada pathrikeyalli ad book madabeku.',
    content: {
      whyAdvertise: 'ಕನ್ನಡ ಪತ್ರಿಕೆಗಳಲ್ಲಿ ಜಾಹೀರಾತು ಏಕೆ ನೀಡಬೇಕು?',
      targetedReach: { title: 'ನಿಖರವಾದ ತಲುಪು (Targeted Reach)', desc: 'ಕನ್ನಡಿಗರನ್ನು ನೇರವಾಗಿ ತಲುಪಿ. ಪ್ರಾದೇಶಿಕ ಪತ್ರಿಕೆಗಳು ಓದುಗರ ನಂಬಿಕೆಯನ್ನು ಗಳಿಸಿವೆ.' },
      costEffective: { title: 'ಕಡಿಮೆ ವೆಚ್ಚ (Cost Effective)', desc: 'ಇಂಗ್ಲಿಷ್ ಪತ್ರಿಕೆಗಳಿಗೆ ಹೋಲಿಸಿದರೆ ಪ್ರಾದೇಶಿಕ ಪತ್ರಿಕೆಗಳಲ್ಲಿ ಜಾಹೀರಾತು ನೀಡುವುದು 30-50% ಅಗ್ಗವಾಗಿದೆ.' },
      higherEngagement: { title: 'ಹೆಚ್ಚಿನ ಸ್ಪಂದನೆ (Higher Engagement)', desc: 'ಓದುಗರು ತಮ್ಮ ಮಾತೃಭಾಷೆಯ ಪತ್ರಿಕೆಗಳನ್ನು ಹೆಚ್ಚು ಆಸಕ್ತಿಯಿಂದ ಓದುತ್ತಾರೆ. ನಿಮ್ಮ ಜಾಹೀರಾತು ಹೆಚ್ಚು ಗಮನ ಸೆಳೆಯುತ್ತದೆ.' },
      howToBook: 'ಕನ್ನಡ ಜಾಹೀರಾತುಗಳನ್ನು ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ಬುಕ್ ಮಾಡುವುದು ಹೇಗೆ?',
      steps: [
        { title: 'ಪತ್ರಿಕೆಯನ್ನು ಆರಿಸಿ', desc: 'ವಿಜಯವಾಣಿ ಅಥವಾ ಪ್ರಜಾವಾಣಿಯಂತಹ ಜನಪ್ರಿಯ ಪತ್ರಿಕೆಗಳನ್ನು ಆರಿಸಿ.' },
        { title: 'ಜಾಹೀರಾತನ್ನು ಬರೆಯಿರಿ', desc: 'ನಿಮ್ಮ ಜಾಹೀರಾತನ್ನು ಕನ್ನಡ ಅಥವಾ ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಬರೆಯಿರಿ. ನಾವು ಉಚಿತ ಅನುವಾದ ಸಹಾಯವನ್ನು ನೀಡುತ್ತೇವೆ!' },
        { title: 'ನಮಗೆ ವಾಟ್ಸಾಪ್ ಮಾಡಿ', desc: 'ವಿವರಗಳನ್ನು ಕಳುಹಿಸಲು ಕೆಳಗಿನ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ. ನಾವು ಕಡಿಮೆ ದರವನ್ನು ತಿಳಿಸುತ್ತೇವೆ.' }
      ]
    }
  },
  english: {
    language: 'English',
    nativeName: 'English',
    title: 'Book English Newspaper Ads',
    headline: 'Book Ads in Top English Newspapers',
    subheadline: 'Times of India, The Hindu, Hindustan Times and more.',
    newspapers: [
      { name: 'Times of India', logo: 'https://www.google.com/s2/favicons?domain=timesofindia.indiatimes.com&sz=128' },
      { name: 'The Hindu', logo: 'https://www.google.com/s2/favicons?domain=thehindu.com&sz=128' },
      { name: 'Hindustan Times', logo: 'https://www.google.com/s2/favicons?domain=hindustantimes.com&sz=128' },
      { name: 'The Statesman', logo: 'https://www.google.com/s2/favicons?domain=thestatesman.com&sz=128' },
      { name: 'The Pioneer', logo: 'https://www.google.com/s2/favicons?domain=dailypioneer.com&sz=128' },
      { name: 'Asian Age', logo: 'https://www.google.com/s2/favicons?domain=asianage.com&sz=128' },
      { name: 'Business Standard', logo: 'https://www.google.com/s2/favicons?domain=business-standard.com&sz=128' },
      { name: 'Financial Express', logo: 'https://www.google.com/s2/favicons?domain=financialexpress.com&sz=128' },
      { name: 'Mint', logo: 'https://www.google.com/s2/favicons?domain=livemint.com&sz=128' },
      { name: 'Deccan Herald', logo: 'https://www.google.com/s2/favicons?domain=deccanherald.com&sz=128' },
      { name: 'The Tribune', logo: 'https://www.google.com/s2/favicons?domain=tribuneindia.com&sz=128' },
      { name: 'The Telegraph', logo: 'https://www.google.com/s2/favicons?domain=telegraphindia.com&sz=128' },
      { name: 'Indian Express', logo: 'https://www.google.com/s2/favicons?domain=indianexpress.com&sz=128' },
      { name: 'Economic Times', logo: 'https://www.google.com/s2/favicons?domain=economictimes.indiatimes.com&sz=128' },
      { name: 'Other', logo: 'https://placehold.co/128x128?text=Other' },
    ],
    whatsappMessage: 'Hi, I want to book an ad in an English newspaper.',
    content: {
      whyAdvertise: 'Why Advertise in English Newspapers?',
      targetedReach: { title: 'Premium Reach', desc: 'Reach the affluent and educated demographic. English newspapers are preferred by decision-makers and urban households.' },
      costEffective: { title: 'National Presence', desc: 'Get nationwide visibility with a single ad. Perfect for brand building and high-value propositions.' },
      higherEngagement: { title: 'Credibility', desc: 'Ads in reputed English dailies carry high trust and prestige, enhancing your brand image.' },
      howToBook: 'How to Book English Ads Online?',
      steps: [
        { title: 'Select Newspaper', desc: 'Choose from top papers like Times of India, The Hindu, or Hindustan Times.' },
        { title: 'Draft Your Ad', desc: 'Write your ad content. We can help you refine it for maximum impact.' },
        { title: 'WhatsApp Us', desc: 'Click the button below to send your details. We\'ll share the best rates instantly.' }
      ]
    }
  }
};
